import i18n from '@/plugin/i18n';

export default [
	{ text: i18n.t('Therapeutic'), value: 1 },
	{ text: i18n.t('Intense'), value: 2 },
	{ text: i18n.t('Resuscitation'), value: 3 },
	{ text: i18n.t('Surgical'), value: 4 }
];
